<template>
    <b-button @click="showModal = true">
        <fa icon="question" :title="$t('New issue')"/>
        <b-modal
            v-model="showModal"
            :title="$t('New issue')"
            hide-footer
            v-bind="$attrs"
        >
            <new-message
                :project-id="projectId"
                :subject="subject"
                @input="showModal = false"
            />
        </b-modal>
    </b-button>
</template>

<script>
    import NewMessage from "@/components/issues/NewMessage";

    export default {
        name: "IssueButton",
        components: {NewMessage},
        props: {
            projectId: {
                type: Number,
                required: true
            },
            subject: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                showModal: false
            }
        }
    }
</script>
